module.exports = __webpack_public_path__ + "img/207.cb6e00fc.png";